import React from 'react'
import Loadable from 'react-loadable'

const ChatProvider = Loadable({
  loader: () => import(/* webpackChunkName: "chat" */ './Provider'),
  loading: ({ children }) => <>{children}</>
})

export default ChatProvider
export { withNativeAudioRecorder } from './Provider/withNativeAudioRecorder'
